import store from '@/store'
import { GoToAction } from '@/store/types'

export enum Colors {
    Success = 'success',
    Info = 'info',
    Error = 'error',
    Warning = 'yellow darken-4',
}

export interface NotifyOptions {
    goToAction?: GoToAction
    subject?: string
    notShowInCenter?: boolean,
}

/**
 * Muestra una notificación al usuario
 *
 * @param {string} message
 * @param {Colors} color
 */
const notify = (message: string, color: Colors = Colors.Success, options?: NotifyOptions) => {
    store.commit('showNotification', { message, color, options })
}

export { notify }
